/**
 * Minimal CSV parser (Unity PortalCsvLoader compatible):
 * - `#` line comments
 * - first non-comment row = header
 * - no quoted commas
 */
export function parseCsv(text: string): { headers: string[]; rows: string[][] } {
  const lines = text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0 && !l.startsWith("#"));
  if (lines.length === 0) return { headers: [], rows: [] };
  const headers = lines[0].split(",").map((h) => h.trim());
  const rows = lines.slice(1).map((line) => line.split(",").map((c) => c.trim()));
  return { headers, rows };
}

export function csvToObjects(text: string): Record<string, string>[] {
  const { headers, rows } = parseCsv(text);
  return rows.map((cells) => {
    const obj: Record<string, string> = {};
    headers.forEach((h, i) => {
      obj[h] = cells[i] ?? "";
    });
    return obj;
  });
}

/** Key,Value sheet → map */
export function csvToKeyValue(text: string): Record<string, string> {
  const rows = csvToObjects(text);
  const map: Record<string, string> = {};
  for (const row of rows) {
    const key = row.Key ?? row.key;
    const value = row.Value ?? row.value;
    if (key) map[key] = value ?? "";
  }
  return map;
}

export function num(map: Record<string, string>, key: string, fallback = 0): number {
  const raw = map[key];
  if (raw === undefined || raw === "") return fallback;
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
}

export function str(map: Record<string, string>, key: string, fallback = ""): string {
  return map[key] ?? fallback;
}
